import type { SVGProps } from 'react';
const SvgBuildingOfficeStreamlineCore = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} fill="none" viewBox="-0.75 -0.75 20 20" {...props}>
    <desc>{'Building Office Streamline Icon: https://streamlinehq.com'}</desc>
    <g stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5}>
      <path d="M1.321 2.643v14.536h10.572V2.643c0-.73-.592-1.322-1.322-1.322H2.643c-.73 0-1.322.592-1.322 1.322M6.607 17.179v-2.643M4.625 10.571V9.25M8.59 9.25v1.321M8.59 4.625v1.321M4.625 4.625v1.321M15.857 7.268h-3.964v9.91h5.286V8.59c0-.73-.592-1.321-1.322-1.321" />
    </g>
  </svg>
);
export default SvgBuildingOfficeStreamlineCore;
